import { type SummaryLength, SummaryLengthSchema } from '../link-preview.js';

export const CONTENT_SUMMARIZER_SYSTEM_PROMPT =
  'You are a precise content summarizer who writes crisp, factual summaries.';

export const SOCIAL_SUMMARIZER_SYSTEM_PROMPT =
  'You are a precise social media summarizer who writes crisp, factual summaries.';

export function parseSummaryLength(value?: string | null): SummaryLength | undefined {
  if (value === undefined || value === null) {
    return;
  }

  const candidate = value.trim();
  const parsed = SummaryLengthSchema.safeParse(candidate);
  if (!parsed.success) {
    throw new Error('Invalid length. Use one of: short, medium, long, xl, xxl.');
  }

  return parsed.data;
}
